module.exports = __webpack_public_path__ + "static/media/usdc.b806ff0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/usdc.svg
// module id = 859
// module chunks = 7